<template>
  <transition-fade appear>
    <div
      v-if="song && song.publicUrl"
      class="flex items-center h-8 w-full text-player-control-default fill-current"
    >
      <button
        @click="$emit('update:playing', !playing)"
        :title="playing ? '&#9646;&#9646; Pauze' : '&#9654; Afspelen'"
        class="w-12 h-12 flex justify-center items-center rounded-full focus:outline-none text-player-icon bg-player-control-default hover:bg-player-control-darkened transition-colors duration-100"
      >
        <transition-fade appear>
          <svg
            v-if="playing"
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="19"
            viewBox="0 0 17 19"
            class="w-6 h-6 p-px fill-current"
          >
            <path d="M0 0h6v19H0zM11 0h6v19h-6z" />
          </svg>
          <svg
            v-else
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="30"
            viewBox="-2 0 16 30"
            class="w-8 h-8 fill-current"
          >
            <path d="M15.25 14.643L0 29.286V0z" />
          </svg>
        </transition-fade>
      </button>

      <progress-control
        :duration="duration"
        :currentTime="currentTime"
        @update:currentTime="seek"
        :muted="muted"
      />

      <volume-control
        :volume="volume"
        @update:volume="$emit('update:volume', $event)"
        :muted="muted"
        @update:muted="$emit('update:muted', $event)"
      />

      <audio
        ref="audio"
        :src="song.publicUrl"
        :muted="muted"
        :volume="volume / 100"
        @durationchange="duration = $refs.audio?.duration"
        @timeupdate="currentTime = $refs.audio?.currentTime"
        @ended="onEnded"
        class="hidden"
      />
    </div>
  </transition-fade>
</template>

<script>
import TransitionFade from "../../../../magic/TransitionFade.vue";
import ProgressControl from "./ProgressControl.vue";
import VolumeControl from "./VolumeControl.vue";

export default {
  name: "SongPlayer",
  components: {
    TransitionFade,
    ProgressControl,
    VolumeControl,
  },
  data() {
    return {
      currentTime: 0,
      duration: undefined,
    };
  },
  props: {
    song: {
      type: Object,
      default: null,
      validator: (song) => !song || Object.keys(song).includes("publicUrl"),
    },
    playing: {
      type: Boolean,
      default: false,
    },
    muted: {
      type: Boolean,
      default: false,
    },
    volume: {
      type: Number,
      default: 75,
      validator: (volume) => volume >= 0 && volume <= 100,
    },
  },
  watch: {
    async playing(playing) {
      if (playing) {
        try {
          // https://github.com/eslint/eslint/issues/12822
          // eslint-disable-next-line no-unused-expressions
          await this.$refs.audio?.play();
        } catch (e) {
          if (e instanceof DOMException && e.name === "AbortError") {
            // Ignore. Happens when either `pause()` is triggered or navigation
            // occurs while the `play()` Promise has not yet been fulfilled.
            return;
          }

          throw e;
        }
      } else {
        // https://github.com/eslint/eslint/issues/12822
        // eslint-disable-next-line no-unused-expressions
        this.$refs.audio?.pause();
      }
    },
    song() {
      // Reset the instance data.
      Object.assign(this.$data, this.$options.data.call(this));
    },
    currentTime() {
      this.$emit("update:currentTime", this.currentTime);
    },
  },
  mounted() {
    this.duration = this.$refs.audio.duration;
  },
  updated() {
    this.duration = this.$refs.audio.duration;
  },
  methods: {
    seek(currentTime) {
      this.$refs.audio && (this.$refs.audio.currentTime = currentTime);
    },
    onEnded() {
      this.seek(0);
      this.$emit("update:playing", false);
    },
  },
};
</script>
